module.exports = __webpack_public_path__ + "static/img/guide-bg.ced10cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guide-bg.png
// module id = pAae
// module chunks = 2